import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Select from "../Select/Select";
import { selectAction, setOtherSettingsAction } from "../../redux/rootReducer";
import { SELECT_INITIAL } from "../../redux/initialStateConstant";
import { GetOtherSettingsThunk } from "../../redux/thunks/GetOtherSettingsThunk";
import { UpdateOtherSettingsThunk } from "../../redux/thunks/UpdateOtherSettingsThunk";

const OtherSettings = () => {
    const dispatch = useDispatch();
    const other_settings = useSelector(state => state.other_settings);

    console.log(other_settings);

    useEffect(() => {
        dispatch(GetOtherSettingsThunk());
    }, [dispatch]);

    return (
        <div className="settings">
            <div className="setting">
                <div className="setting__caption">Сервис SMS-рассылки</div>
                <Select
                    current={
                        other_settings.sms_service === 'rocketsms' ? 'Rocketsms'
                            : other_settings.sms_service === '' ? 'Смс отключены' : ''
                    }
                    type={ 'sms_service' }
                    options={ [{ id: '', name: 'Смс откючены' }, { id: 'rocketsms', name: 'Rocketsms' }] }
                    handler={ elem => {
                        dispatch(UpdateOtherSettingsThunk({
                            field: 'sms_service',
                            value: elem.id
                        }));
                        dispatch(selectAction(SELECT_INITIAL));
                    } }
                />
            </div>
            <div className="setting">
                <div className="setting__caption">Имя пользователя sms-сервиса</div>
                <input type="text" className="input"
                       value={ other_settings.sms_username }
                       onInput={ event => {
                           dispatch(setOtherSettingsAction({
                               ...other_settings,
                               sms_username: event.target.value
                           }));
                       } }
                       onBlur={ () => {
                           dispatch(UpdateOtherSettingsThunk({
                               field: 'sms_username',
                               value: other_settings.sms_username
                           }));
                       } }
                />
            </div>
            <div className="setting">
                <div className="setting__caption">Пароль от sms-сервиса</div>
                <input type="text" className="input"
                       value={ other_settings.sms_password }
                       onInput={ event => {
                           dispatch(setOtherSettingsAction({
                               ...other_settings,
                               sms_password: event.target.value
                           }));
                       } }
                       onBlur={ () => {
                           dispatch(UpdateOtherSettingsThunk({
                               field: 'sms_password',
                               value: other_settings.sms_password
                           }));
                       } }
                />
            </div>
        </div>
    );
};

export default OtherSettings;